import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[loadComponent]',
    standalone: false
})
export class DynamicComponentDirective {
    constructor(public viewContainerRef: ViewContainerRef) { }
}